import React from 'react';
import { Grid } from '@mui/material';

import { useFormState } from 'shared/hooks';
import useConsultData from 'features/consults/hooks/useConsultData';
import useConsultInitialFormState from 'features/consults/hooks/useConsultInitialFormState';

import GridWrapper from 'shared/components/layout/GridWrapper/GridWrapper';
import { CONSULT_TABS } from 'features/consults/utils/constants';
import ExamPanel from 'features/consults/shared/tabs/Exam/ExamPanel';
import schema from 'features/consults/shared/tabs/Exam/validationSchema';

import { leftPanels, rightPanels } from './data';

const Exam = () => {
  const { control, register, getValues, setFormValues, getFieldError } =
    useFormState(schema, { stateSlice: 'consults', showAsSnackbar: true });
  const { consult, consultTabData, isEditable, handleFieldChange } =
    useConsultData(CONSULT_TABS.EXAM, getValues);

  useConsultInitialFormState(consult.id, consultTabData, setFormValues);

  return (
    <GridWrapper>
      <Grid item xs={12} lg={6}>
        {leftPanels.map((section, index) => (
          <ExamPanel
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            section={section}
            control={control}
            register={register}
            getFieldError={getFieldError}
            onChange={handleFieldChange}
            disabled={!isEditable}
          />
        ))}
      </Grid>
      <Grid item xs={12} lg={6}>
        {rightPanels.map((section, index) => (
          <ExamPanel
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            section={section}
            control={control}
            register={register}
            getFieldError={getFieldError}
            onChange={handleFieldChange}
            disabled={!isEditable}
          />
        ))}
      </Grid>
    </GridWrapper>
  );
};

export default Exam;
